import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { getErrorFormat } from 'core/utils/errors';
import { AlertNotificationUserListResponsePayload } from '../models';
import { payloadToAlertNotificationUserList } from '../mappers';

const getUrl = ({ host, projectId }: { host: string; projectId: string }) => {
  return `${host}/alert-notifications/user-list/${projectId}`;
};

export const GetAlertNotificationUserList = async ({ host, token, projectId }: { host: string; token: string; projectId: string }) => {
  try {
    const url = getUrl({ host, projectId });

    const options: AxiosRequestConfig = {
      url,
      method: 'GET',
      timeout: 10000,
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json;charset=UTF-8',
        Authorization: token,
        'Accept-version': '1',
      },
    };

    const { data } = (await axios(options)) as AxiosResponse<AlertNotificationUserListResponsePayload>;
    return payloadToAlertNotificationUserList(data);
  } catch (error) {
    throw getErrorFormat(error);
  }
};
